export const HIDE_FOOTER = 'HIDE_FOOTER';
export const SHOW_FOOTER = 'SHOW_FOOTER';

export const hideFooter = () => ({
    type: HIDE_FOOTER
});

export const showFooter = () => ({
    type: SHOW_FOOTER
});
